import { EventGS, EventGSToken } from '../core/EventsGS';
import { WrapperGS } from '../core/WrapperGS';
import { InputGS } from './InputGS';

export class InputFilesGS extends InputGS
{
    static override ForHTMLElement(el: HTMLElement): boolean {
        if (el.nodeName.toLowerCase() === 'input') {
            const inputEl = el as HTMLInputElement;
            return inputEl.type === 'file';
        }
        return false;
    }

    private readonly _onFilesSelectedToken: EventGSToken<File[]>;
    public readonly onFilesSelected: EventGS<File[]>;

    constructor(el: HTMLInputElement | string) {
        super(el);
        this._onFilesSelectedToken = new EventGSToken<File[]>(() => {
            this.el.addEventListener('change', () => this.onChangeHandler());
        });
        this.onFilesSelected = new EventGS<File[]>(this._onFilesSelectedToken);
    }

    /** Opens the native file-selection dialog. */
    public open(): void {
        this.el.click();
    }

    /** Returns a snapshot of the files currently selected by the user. */
    public get files(): File[] {
        return this.el.files ? Array.from(this.el.files) : [];
    }

    /** Clears the current selection. Browsers do not allow restoring it programmatically. */
    public clear(): void {
        this.value = '';
    }

    private onChangeHandler(): void {
        const list = this.files;
        if (list.length === 0) return;
        this._onFilesSelectedToken.invoke(list);
    }
}

WrapperGS.ExtendComponentsByHTMLElement(InputFilesGS);
